<div class="component-container">
  <div class="image-with-caption">
    <div class="layout-large">
      <div class="layout-content">
        <div class="row">
          <div class="col-lg-7 col-md-7 col-xs-8">
            <div class="media">
              <div class="media-body">


                <div class="media-right media-middle image-with-caption-container">
                  <a href="http://cms.outdooraccess.com/list-my-land/" target="_blank">

                    
                    <picture>
                      <source
                        srcset="https://cdn.outdooraccess.com/oa-assets/images/misc/smith-family-fishing-large.jpg"
                        media="(min-width: 1024px)"
                      />
                      <source
                        srcset="https://cdn.outdooraccess.com/oa-assets/images/misc/smith-family-fishing-med.jpg"
                        media="(min-width: 768px)"
                      />
                      <source srcset="https://cdn.outdooraccess.com/oa-assets/images/misc/smith-family-fishing-sm.jpg" 
                        media="(min-width: 800px)" />
                      <img
                        src="https://cdn.outdooraccess.com/oa-assets/images/misc/smith-family-fishing-sm.jpg"
                        class="img-rounded"
                        alt=""
                      />
                    </picture>


                  </a>
                  <div class="caption-text">
                    <p>
                      “Since I’ve signed up for Outdoor Access, I’ve had a great experience! Every single person has been polite and
                      respectful – I would highly recommend it … and you get a nice check in the mail!" - Lindsay, Upper Marlbourne
                      Homeplace
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
